// Here we can define any theme that follows the CustomThemeInterface type from @atbay/theming
export const theme = {
    colors: {
        primary: {
            40: '#EAF1FB',
            50: '#B3D4FC',
            100: '#7FB6F8',
            200: '#4F8CFF',
            300: '#3572E5',
            400: '#2851A3',
            500: '#1B355D',
            600: '#14213D',
            700: '#0E1624',
            800: '#0A1020',
            900: '#4F8CFF',
            950: '#002050',
        },
        greys: {
            0: '#FFFFFF',
            50: '#1A1A1A',
            75: '#242424',
            100: '#2D2D2D',
            200: '#363636',
            300: '#404040',
            400: '#AFAFAF',
            500: '#919191',
            600: '#808080',
            700: '#999999',
            800: '#B3B3B3',
            900: '#CCCCCC',
        },
        reds: {
            0: '#F02A26',
            100: '#FFB3B3',
            200: '#F02A261A',
            300: '#EB100040',
            400: '#A41512',
            500: '#FF4C4C',
            600: '#D31D1A',
            700: '#952424',
            800: 'rgba(164, 21, 18, 0.08)',
            900: 'rgba(185, 23, 20, 0.18)',
            950: '#FFB3B359',
        },
        greens: {
            100: '#C6F6D5',
            600: '#22D184',
            800: '#14942A',
        },
        yellows: {
            900: '#FFD600',
        },
        teals: {
            900: '#14979D',
            800: '#4FD1C5',
        },
        semantic: {
            success: '#22D184',
            successLight: '#2AF598',
            successDark: '#14942a',
            moderate: '#FFD600',
            moderateLight: '#FFF7B6',
            warning: '#FFB020',
            warningLight: '#FFD9B6',
            error: '#FF4C4C',
            errorLight: '#FFB3B3',
            severityBadgeCriticalText: '#FF8C8C',
            severityBadgeCriticalBorder: 'rgba(240, 76, 76, 0.40)',
            severityBadgeCriticalBackground: 'rgba(240, 42, 38, 0.12)',
            severityBadgeImportantText: '#FFB266',
            severityBadgeImportantBorder: 'rgba(255, 123, 0, 0.40)',
            severityBadgeImportantBackground: 'rgba(255, 123, 0, 0.12)',
            severityBadgeModerateText: '#E8DC7A',
            severityBadgeModerateBorder: 'rgba(255, 244, 120, 0.40)',
            severityBadgeModerateBackground: 'rgba(255, 244, 120, 0.12)',
            severityBadgeLowText: '#7FB6F8',
            severityBadgeLowBorder: 'rgba(79, 140, 255, 0.40)',
            severityBadgeLowBackground: 'rgba(79, 140, 255, 0.12)',
            severityBadgeInfoText: '#B3B3B3',
            severityBadgeInfoBorder: 'rgba(179, 179, 179, 0.40)',
            severityBadgeInfoBackground: 'rgba(179, 179, 179, 0.12)',
            errorDark: '#7F090A',
            successBackground: '#1B355D',
            neutral: '#353945',
            dark: '#101114',
            separator: 'rgba(255,255,255,0.08)',
            gradientTop: '#181A20',
            gradientBottom: '#181A20',
            background: '#181A20',
            backgroundSecondary: '#23272F',
            drawerBackground: '#23272F',
            simpleMenu: '#23272F',
            sideBarSlider: '#121418',
            sideBarActivate: '#4F8CFF',
            tabActivate: '#4F8CFF',
            contentSeparator: 'rgba(255,255,255,0.08)',
            drawerSeparator: 'rgba(255,255,255,0.08)',
            topPageSeparator: 'rgba(255,255,255,0.08)',
            dialogHeader: '#23272F',
            filterReset: '#353945',
            muiCheckedBackground: '#2A3F66',
            muiTrackBackground: 'rgba(79,140,255,0.3)',
            muiUnCheckedBackground: '#323948',
            muiUnCheckedLightBackground: '#23272F',
            summaryIndicator: '#353945',
            filterUnActive: '#353945',
            secondarySeparator: 'rgba(255,255,255,0.04)',
            tag: '#23272F',
            validDomain: '#4F8CFF',
            inValidDomain: '#FF4C4C',
            inValidCloseBtn: '#FF4C4C',
            validCloseBtn: '#4F8CFF',
            securityScoreSuccess: '#22D18433',
            securityScoreModerate: '#FFD60033',
            securityScoreWarning: '#FFB02033',
            securityScoreError: '#FF4C4C54',
            securityTrainingText: '#B0B3B8',
            securityTraining: '#23272F',
            liveAnimation: 'rgba(79, 140, 255, 0.7)',
            issueLabel: '#7A7F92',
            selectedIssueCategories: '#4F8CFF',
            sendNewInvitationBackground: '#002050',
            sendNewInvitationBackgroundSecondary: '#FFFFFF',
            sendNewInvitationText: '#191919',
            reason: '#FFB3B359',
            statusResolvedLight: '#22D1841A',
            statusOpenLight: '#FF4C4C1A',
            caseLightGreen: '#22D1841A',
            caseLightGreenBorder: 'rgba(34, 209, 132, 0.5)',
            caseLightRed: 'rgba(255, 76, 76, 0.08)',
            caseLightRedBorder: 'rgba(255, 76, 76, 0.18)',
            openCasesTypeIncidentTextColor: '#FF4C4C',
            openCasesTypeIncidentStatus: '#FF4C4C',
            openCasesTypeIncidentBackgroundColor: '#FFB3B3',
            openCasesTypeServiceRequestTextColor: '#4F8CFF',
            openCasesTypeServiceRequestStatus: '#14213D',
            openCasesTypeServiceRequestBackgroundColor: '#23272F',
            openCasesBackground: '#23272F',
            openCasesBorder: 'rgba(255,255,255,0.08)',
            alertCritical: '#FF4C4C',
            alertHigh: '#FFB020',
            alertMedium: '#FFD600',
            alertLow: '#7A7F92',
            alertInfo: '#CCCCCC',
            gridColor: 'rgba(255,255,255,0.06)',
            demoAccountBanner: '#1B355D',
            alertsOverTimeGradientTop: '#D9EBFF',
            alertsOverTimeGradientBottom: '#1B355D',
            googleAndMicrosoftIcon: '#1B355D',
            inputBorder: '#23272F',
            mdrDemoOverlay: 'rgba(24, 26, 32, 0.80)',
            sideBarBackground: '#23272F',
            sidebarText: '#AFAFAF',
            headerBorder: '#404040',
            headerShadow: 'rgba(255, 255, 255, 0.2)',
            tableScrollShadow: 'rgba(255, 255, 255, 0.05)',
            filterLabelBackground: '#19273d',
            primaryText: '#B3D4FC',
            primaryTextHover: '#7FB6F8',
            tableHeader: '#23272F',
            tableBorder: '#404040',
            tableActive: '#40444B',
            tableHover: '#353945',
            filterPopupFooterBackground: '#23272F',
            statusOpenText: '#FCF2F2',
            statusValidatingText: '#F2F2F2',
            statusResolvedText: '#07AF26',
            statusApprovedText: '#F2F2F2',
            statusOpenBackground: '#F02A261A',
            statusValidatingBackground: 'rgba(75, 85, 99, 0.05)',
            statusResolvedBackground: 'rgba(7, 175, 38, 0.10)',
            statusApprovedBackground: 'rgba(75, 85, 99, 0.15)',
            statusOpenBorder: 'rgba(240, 76, 76, 0.40)',
            statusValidatingBorder: 'rgba(242, 242, 242, 0.20)',
            statusResolvedBorder: 'rgba(7, 175, 38, 0.40)',
            statusApprovedBorder: 'rgba(242, 242, 242, 0.20)',
            statusActiveBackground: 'rgba(7, 175, 38, 0.10)',
            statusBrokenBackground: '#F02A261A',
            statusActiveText: '#07AF26',
            statusBrokenText: '#FCF2F2',
            assetsExportButton: '#667996',
            overviewListItemIconBackground: '#404040',
            overviewSeparator: 'rgba(255,255,255,0.2)',
            activationButton: '#4F8CFF',
            activationButtonHover: '#7FB6F8',
            bannerBackgroundInfo: '#23272F',
            bannerBackgroundWarning: '#353945',
            bannerBackgroundError: '#F02A261A',
            bannerBorderWarning: '#696969',
            bannerBorderInfo: '#404040',
            bannerIconBackground: '#45537E',
            bannerIconBackgroundError: 'rgba(211, 29, 26, 0.25)',
            bannerIconBorder: '#45537E',
            bannerIconColor: '#FFFFFF',
            marketingInfoBannerBackground: '#23272F',
            secondaryButtonColor: '#F3F6FF',
            secondaryButtonHoverColor: '#5489FF',
            markAsResolvedFormBackground: '#191A1E',
            seeWhyHoverColor: '#FFFFFF',
            tableHeaderText: '#B3B3B3',
            integrationProviderCardDivider: '#404040',
            partialActiveIndicator: '#FF7B00',
            partialActiveIndicatorHover: '#FF9533',
            contactExpertLink: '#4F8CFF',
            contactExpertLinkHover: '#7FB6F8',
            integrationCardBoxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
            integrationCardHoverBoxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
            integrationCardHoverBorder: '#4F8CFF',
            integrationCardArrowButtonHover: '#4F8CFF',
            collapsingBannerBorder: '#353945',
            collapsingBannerIcon: '#FF4C4C',
        },
        toast: {
            background: '#23272F',
            error: '#FF4C4C',
            success: '#22D184',
            info: '#4F8CFF',
            warning: '#FFB020',
        },
        main: '#4F8CFF',
    },
    fonts: {
        'xxxl-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '5rem',
        },
        'xxxl-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '5rem',
        },
        'xxxl-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '5rem',
        },
        'xxxl-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '5rem',
        },
        'xxxl-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '5rem' },
        'xxl-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '3.2rem',
        },
        'xxl-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '3.2rem',
        },
        'xxl-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '3.2rem',
        },
        'xxl-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '3.2rem',
        },
        'xxl-bold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '3.2rem',
        },
        'xl-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '2.4rem',
        },
        'xl-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2.4rem',
        },
        'xl-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '2.4rem',
        },
        'xl-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '2.4rem',
        },
        'xl-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '2.4rem' },
        'l-light': { fontFamily: 'Lato', fontWeight: 300, fontSize: '1.8rem' },
        'l-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.8rem',
        },
        'l-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.8rem',
        },
        'l-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.8rem',
        },
        'l-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.8rem' },
        'm-light': { fontFamily: 'Lato', fontWeight: 300, fontSize: '1.6rem' },
        'm-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.6rem',
        },
        'm-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.6rem',
        },
        'm-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.6rem',
        },
        'm-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.6rem' },
        's-light': { fontFamily: 'Lato', fontWeight: 300, fontSize: '1.4rem' },
        's-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.4rem',
        },
        's-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.4rem',
        },
        's-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.4rem',
        },
        's-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.4rem' },
        'xs-light': {
            fontFamily: 'Lato',
            fontWeight: 300,
            fontSize: '1.2rem',
        },
        'xs-regular': {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.2rem',
        },
        'xs-medium': {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.2rem',
        },
        'xs-semibold': {
            fontFamily: 'Lato',
            fontWeight: 600,
            fontSize: '1.2rem',
        },
        'xs-bold': { fontFamily: 'Lato', fontWeight: 700, fontSize: '1.2rem' },
        mainSM: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1rem',
        },
        pri10L: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1rem',
        },
        pri12L: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1.2rem',
        },
        pri14L: {
            fontFamily: 'Lato',
            fontWeight: 200,
            fontSize: '1.4rem',
        },
        pri10R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1rem',
        },
        pri12R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.2rem',
        },
        pri14R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.4rem',
        },
        pri16R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.6rem',
        },
        pri18R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '1.8rem',
        },
        pri20R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2rem',
        },
        pri24R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2.4rem',
        },
        pri28R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '2.4rem',
        },
        pri32R: {
            fontFamily: 'Lato',
            fontWeight: 400,
            fontSize: '3.2rem',
        },
        pri10RX: {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1rem',
        },
        pri12RX: {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.2rem',
        },
        pri14RX: {
            fontFamily: 'Lato',
            fontWeight: 500,
            fontSize: '1.4rem',
        },
        pri10B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1rem',
        },
        pri12B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.2rem',
        },
        pri14B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.4rem',
        },
        pri16B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.6rem',
        },
        pri18B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '1.8rem',
        },
        pri20B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '2rem',
        },
        pri24B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '2.4rem',
        },
        pri28B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '2.8rem',
        },
        pri32B: {
            fontFamily: 'Lato',
            fontWeight: 700,
            fontSize: '3.2rem',
        },
        sec10R: {
            fontFamily: 'Pressura',
            fontWeight: 400,
            fontSize: '1rem',
        },
        sec12R: {
            fontFamily: 'Pressura',
            fontWeight: 400,
            fontSize: '1.2rem',
        },
    },
}
